import React from 'react';
import Background from '../Assets/images/flowing_line_yellow.svg';
import PropTypes from 'prop-types';
// CSS
import './Background.css';

//#region COMPONENT
/**
 * @returns {JSX.Element} The background component
 * @param {object} props The component props
 * @param {string} props.bgColor The background color
 */
const AppBackground = props => {
  const { bgColor = '#14141A', zIndex = null } = props;
  //#region INTERFACE
  return (
    <Background
      width={'100vw'}
      height={'100vh'}
      preserveAspectRatio="xMidYMid slice"
      className="Background"
      style={{ backgroundColor: bgColor, zIndex: zIndex }}
    />
  );
  //#endregion
};

// PropTypes
/**
 * @type {object} propTypes The component prop types
 * @property {string} bgColor The background color
 */
AppBackground.propTypes = {
  bgColor: PropTypes.string,
};
//#endregion

export { AppBackground };
